// -----------------------------------------------------------------[ LIBS ]--------------------------------------------------------------//
// jQuery removed - use DOMHelpers and vanilla DOM APIs
import DOMHelpers from './utils/dom-helpers';

//---------- AJAX ----------------------------------------------//
import barba from '@barba/core';
import barbaPrefetch from '@barba/prefetch';

//---------- SMOOTH SCROLL -------------------------------------//
import Lenis from 'lenis';

//---------- ANIMATION AND SCROLL CONTROLL (TRIGGER) -----------//
import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { DrawSVGPlugin } from 'gsap/DrawSVGPlugin';

// plugin registry gsap
gsap.registerPlugin(ScrollToPlugin, ScrollTrigger, DrawSVGPlugin);

//---------- LAZYLOAD IMAGES -----------------------------------//
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/object-fit/ls.object-fit';
import lazySizes from 'lazysizes';

lazySizes.cfg.loadMode = 1; // default to 2
lazySizes.cfg.expFactor = 1; //1.1; // default 1.5	
lazySizes.cfg.expand = 0; //100; // 370-500
lazySizes.cfg.init = false;

//---------- LOADING BAR ---------------------------------------//
import NProgress from 'nprogress';
//---------- UTILS ---------------------------------------------//
// import { debounce as _debounce } from 'underscore';

//---------- MOUSE/TOUCH DETECTION -----------------------------//
import * as detectIt from 'detect-it';

import { clearAllBodyScrollLocks } from 'body-scroll-lock';

// -----------------------------------------------------------------[ CONTROLLERS ]-----------------------------------------------------//
import Layout from './layout';
import WIDGETS from './widgets';
import EFFEX from './effex';
import { forEach } from 'es-toolkit/compat';


// ---- GLOBALS ?? (ESLINT don't bother) -----------------------//
let _ga = window.ga,
	_gtag = window.gtag,
	console = window.console;


// -----------------------------------------------------------------[ MAIN CLASS ]-----------------------------------------------------//
export class MainSmooth { // export class Main

	constructor(options) {

		// OPTIONS
		this.defaults = {
			is_ajax: true,
			time_fade_in: 0.3,
			time_fade_out: 0.2,
			$scroll_el: 'body',
			debug: false,
			cacheIgnore: false,
			project_name: 'New Project',
			is_lenis: false,
			redirects: [],

			slide_transition: true,
			scrollTo0AfterPageLoad: false,

			// transition to 0 on page leave
			scrollTo0BeforePageLoad: false,

			fakeHeaderTransition: true,

			skip_logo_animation : false,

			admin_button: '.wordpress-edit-button',

			GA_MEASUREMENT_ID: '', //'UA-23082040-1',
			GA_TAG_MANAGER: '' //'GTM-NW4KZZ'
		}

		this.options = {};
		Object.assign(this.options, this.defaults, options);
		this.namespace = 'main';

		// DOM helpers
		this.dom = new DOMHelpers(document);

		// VARS (vanilla DOM)
		this.window = window;
		this.document = document;
		this.htmlEl = document.documentElement;
		this.body = document.body;

		// convenience shorthands
		this.qs = this.dom.qs.bind(this.dom);
		this.qsa = this.dom.qsa.bind(this.dom);
		this.on = this.dom.on.bind(this.dom);
		this.off = this.dom.off.bind(this.dom);
		this.addClass = this.dom.addClass.bind(this.dom);
		this.removeClass = this.dom.removeClass.bind(this.dom);
		this.hasClass = this.dom.hasClass.bind(this.dom);
		this.htmlToDoc = this.dom.htmlToDoc.bind(this.dom);

	}

	init() {

		this.avoidScrollRestoration();

		window.scrollTo(0, 0);

		this.detectIt();

		this.initLoading();

		this.initAjax();

		// this.debounceResize(true);

		lazySizes.init();

		if (!this.options.is_ajax) {
			this.onOnceReady();
		}

		//----------------------------------------------------------------[ CONTROLLERS ] ---------------------------------------------------------------//
		// All JS Effects (Mostly Scroll Triggers )
		this.EFFEX = new EFFEX({ main: this, debug: this.options.debug });

		// Widgets inits
		this.WIDGETS = new WIDGETS({ main: this });

		// All HTML interface (Menus, Mobile Panels, etc.)
		this.LAYOUT = new Layout({ main: this, skip_intro: this.options.skip_intro });

		this.initPageSpecific(this.body, true, true);

		//this.outlineInAccessibleWay();

		setTimeout(() => this.initScroll(true), 17);

		this._logFOUO(this.options.project_name);
	}

	avoidScrollRestoration(){
		// This prevents the page from restoring the scroll position
		if ('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}

		// Scroll to the top when the page loads
		window.onload = function() {
			this.setTimeout( ()=> {window.scrollTo(0, 0) }, 100 );
		};		
	}

	// -----------------------------------------------------------------[ MOUSE/TOUCH DETECTION ]-------------------------------------------------------//
	detectIt() {

		const isSmallViewport = window.matchMedia('(max-width: 767px)').matches;
		// const isMobile = isTouch || isSmallViewport;

		// https://github.com/rafgraph/detect-it
		// #readme
		switch (detectIt.deviceType) {
			//'mouseOnly' / 'touchOnly' / 'hybrid'
			case 'mouseOnly':
				this.addClass(this.htmlEl, 'no-touch');
				if (!isSmallViewport) {
					this.addClass(this.htmlEl, 'desktop');
				}
				break;
			case 'touchOnly':
				this.addClass(this.htmlEl, 'touch');
				if (isSmallViewport) {
					this.addClass(this.htmlEl, 'mobile');
				}
				break;
			default:
				// 'mouse' / 'touch';
				this.addClass(this.htmlEl, detectIt.primaryInput === 'mouse' ? 'hybrid no-touch' : 'hybrid touch');
		}

		if (this.isPageInIframe()) {
			this.addClass(this.htmlEl, 'loaded-in-iframe');
		}

	}

	isPageInIframe() {
		try {
			return window.location !== window.parent.location;
		} catch (_e) {
			return true;
		}
	}


	// -----------------------------------------------------------------[ INIT BARBA ]--------------------------------------------------------------//
	initAjax() {
		if (this.options.is_ajax) {

			// tell Barba what plugins to use
			barba.use(barbaPrefetch);

			barba.init({

				cacheIgnore: this.options.cacheIgnore,

				debug: this.options.debug,

				// default 2000
				timeout: 7000,

				// wait if a link is clicked and there is a page transition running
				preventRunning: true,

				prevent: ({ el }) => {

					if (this.options.redirects.length > 0) {
						let pathname = el.pathname, i = this.options.redirects.length;
						if (pathname) {
							while (i--) {
								if (pathname === this.options.redirects[i][0]) {
									el.pathname = this.options.redirects[i][1];
								}
							}
						}
					}

					return el.classList && el.classList.contains('no-barba')
				},

				transitions: [

					{
						name: 'default-transition', // slide_transition, or slided_transition = false => fade

						once: () => this.onOnceReady(),

						before: (data) => this.barba_commons('before', data),

						// TRANSITION ON CURRENT PAGE
						leave: (data) => {

							// barba VIEW!
							let checkView = this.barba_is_view(data.current.container, data),
								is_view = checkView[0],
								container = checkView[1],
								duration = this.options.time_fade_out;
								//footerEl = this.qs('#footer');

							//console.log( 'fade out, t = ' + duration );

							if (this.options.slide_transition && !is_view) {
								let t = gsap.timeline();

								t.fromTo(container, { y: 0 }, { y: -50, opacity: 0, duration: duration, ease: 'Power3.easeOut' });
								t.fromTo(this.qs('#curtain'), { y: "100%" }, { y: "0%", ease: 'Power3.easeOut', duration: duration }, '-=' + duration);

								return t;
							}
							else {
								//if (footerEl) gsap.to(footerEl, { opacity: 0, duration: duration - 0.1 });
								// fade out
								return gsap.to(container, {
									opacity: 0,
									duration: duration
								});
							}
						},

						afterLeave: (data) => this.barba_commons('afterLeave', data),

						//------> Here is when data.next.container is added to the DOM!

						beforeEnter: (data) => this.barba_commons('beforeEnter', data),

						// TRANSITION ON NEXT PAGE
						enter: (data) => {

							// barba VIEW!
							let checkView = this.barba_is_view(data.next.container, data),
								is_view = checkView[0],
								container = checkView[1],
								duration = this.options.time_fade_in,
								footerEl = false; //this.qs('#footer');

							//console.log( 'fade in, t = ' + duration );

							if (this.options.slide_transition && !is_view) {
								let t = gsap.timeline();

								t.fromTo(this.qs('#curtain'), { y: "0%" }, { y: "-100%", ease: 'Power3.easeOut', duration: duration });
								t.fromTo(container, { y: 300, opacity: 0 }, {
									y: 0, opacity: 1, duration: duration, ease: 'Power3.easeOut', onUpdate: () => { this.afterCompletePageTransitions() }, onComplete: () => {
										// eliminate tranform so if there are pinned elemnet they behave correctly
										gsap.set(container, { clearProps: "all" });

										this.afterCompletePageTransitions()
									}
								}, '-=' + duration);

								return t;

							}
							else {


								if ( is_view ){
									this.prepareImagesIfWiew( data );
								}
								

								// fade In
								return gsap.from(container, {
									opacity: 0,
									duration: duration,
									onComplete: () => { if (footerEl) gsap.set(footerEl, { opacity: 1 }); this.afterCompletePageTransitions() }
								});
							}
						},

						after: (data) => this.barba_commons('after', data)

					}
				]
			})
		}
	}

	prepareImagesIfWiew( data ){
		// return;
		
		// make sure lazyload images outside the view are loaded right away
		let imgs = data.next.container.querySelectorAll( '.lazyload' ),
			//previmgs = data.current.container.querySelectorAll( '.lazyload' ),
			viewClass = '.' + data.trigger.getAttribute('data-view'),
			src = false;

		if ( imgs.length ){
			imgs.forEach( (el, i) =>{
				if( this.dom.parents( el, viewClass ).length === 0 ){
					src = this.getImagePreloadOutsideView( el );
					if ( src ){
						this.dom.removeClass( el, 'lazyload' );
						this.dom.removeClass( el, 'lazyloading' );
						this.dom.removeClass( el, 'lazyload-persist' );
						//this.dom.addClass( el, 'no-transition' );
						el.style.opacity = 1;
						el.setAttribute( 'src', src );
					}
				}
			})
		}
	}

	preloadImagesIfWiew( data ){
		//return;
		//console.log( 'preloadImagesIfWiew', data );
		
		let has_view = data ? data.next.container.querySelector('.barba-view') : this.dom.qs( '.barba-view' );

		if ( has_view ){
			let viewClass = '.' + has_view.getAttribute('data-view'), 
				imgs = data ? data.next.container.querySelectorAll( '.lazyload' ) : this.dom.qsa( '.lazyload' ),
				src = false,
				preload;	
			if ( imgs.length ){
				imgs.forEach( (el, i) =>{
					if( this.dom.parents( el, viewClass ).length === 0 ){

						src = this.getImagePreloadOutsideView( el );
						//console.log( 'img outside view found', el );

						if ( src ){
							//console.log( 'preloading image outside view: ' + src );
							el.setAttribute( 'src', src );
							preload = new Image();
							preload.src = src;
						}
					}
				})
			}
		}
	}

	getImagePreloadOutsideView( el ){
		return el.getAttribute( 'data-srcset' ).split(',')[0].split(' ')[0];
	}

	// -----------------------------------------------------------------[ BARBA UTILS ]--------------------------------------------------------//
	barba_is_view(containerEl, data) {
		// containerEl expected to be a DOM element
		if (data.trigger && data.trigger.classList && data.trigger.classList.contains('barba-view')) {
			const viewName = data.trigger.getAttribute('data-view');
			if (viewName) {
				let view = containerEl.querySelector('.' + viewName);
				if (view) return [true, view];
			}
		}
		return [false, containerEl];
	}

	barba_commons(mode, data) {
		switch (mode) {
			case 'before':
				// set loading
				this.setLoading(true);
				// used for managing back buttom
				this.recordState(true, data);
				this.setLeaveTransition(data);
				break;
			case 'afterLeave':
				this.initScroll(false);
				this.initPageSpecific(data.current.container, false, false);
				break;

			//------> Here is when data.next.container is added to the DOM!

			case 'beforeEnter':
				// remove old container
				if (data.current && data.current.container) data.current.container.remove();
				// change body classes
				this.setBodyClass(data.next.html);
				// init new page
				this.initPageSpecific(data.next.container, true, false);
				// init scroll
				this.initScroll(true);
				// set scroll
				this.setPositionScrollAfterPageEnter(data);
				// track page view
				this.setGA(window.location.pathname, window.location.href);
				// set loading
				this.setLoading(false);
				// fix admin button page link
				this.updateAdminButton(data.next.html);
				break;
			case 'after':
				setTimeout( ()=>this.preloadImagesIfWiew(data), 400 );
				break;
		}
		this.LAYOUT.onBarbaChangeState(mode, data);
	}

	barba_triggerURL(url, el) {
		if (this.options.is_ajax) {
			barba.go(url, el instanceof Element ? el : undefined);
		}
		else {
			document.location = url;
		}
	}

	barba_history_add(url, el, title) {
		if (this.options.is_ajax) {
			barba.history.add(url, el instanceof Element ? el : undefined);
			if (title) {
				this.changeHTMLTitle(title);
			}
		}
	}

	barba_history_previous() {
		return barba.history.previous;
	}

	setBodyClass(html) {
		let parser = new DOMParser(), doc;
		doc = parser.parseFromString(html, "text/html");
		this.body.className = doc.body.getAttribute('class') || '';
		html = parser = doc = null;
	}

	changeHTMLTitle(str) {
		document.title = str;
	}

	onOnceReady() {
		this.setLoading(false);
		this.preloadImagesIfWiew();
		this.LAYOUT.onBarbaChangeState('beforeEnter');
	}
	// -----------------------------------------------------------------[ END BARBA ]--------------------------------------------------------------//


	// -----------------------------------------------------------------[ SCROLL ]-----------------------------------------------------------//

	initScroll(b) {

		if ( b && this.options.is_lenis && this.body.classList.contains( 'home' ) && !this.htmlEl.classList.contains( 'end-logo-anim' ) ){
			return;
		}


		if (!this.options.is_lenis || this.hasClass(this.htmlEl, 'touch') || window.innerWidth <= 768) {
			return
		}

		if (this.options.scrollTo0AfterPageLoad) {
			gsap.to(window, { duration: 0, scrollTo: 0 });
		}

		if (b) {

			if (this.scroll) {
				this.scroll.destroy();
				this.scroll = false;
			}
			// init Lenis
			const lenis = new Lenis({
				infinite: false,
				//content 	: document.querySelector('#smooth-scroll')
			});

			lenis.on('scroll', (e)=>{
				ScrollTrigger.update()
			});

			gsap.ticker.add((time) => {
				lenis.raf(time * 1000)
			})

			gsap.ticker.lagSmoothing(0);

			this.scroll = lenis;

			if (this.options.scrollTo0AfterPageLoad) {
				gsap.to(window, { duration: 0, scrollTo: 0 });
				this.scroll.scrollTo(0);
			}

		}
		else {

			if (this.scroll) {
				this.scroll.destroy();
			}

		}
	}

	pauseScroll(b){
		if ( this.scroll ){
			if ( b ){
				this.scroll.stop()
			}
			else{
				this.scroll.start()
			}
		}
	}

	// called by modals
	onOpenModal(b) {
		if (!this.scroll) {
			return;
		}
		if (b) {
			this.scroll.stop()
		}
		else {
			this.scroll.start()
		}
	}


	afterCompletePageTransitions() {
		if (this.options.is_lenis) {
			//ScrollTrigger.refresh();
			//this.scroll.update();
		}
	}

	setLeaveTransition( data ){
		let checkView = this.barba_is_view(data.current.container, data),
			is_view = checkView[0],
			y = 0;
		if ( this.options.scrollTo0BeforePageLoad && !is_view && this.window.innerWidth >= 1204 ){
			y = data.current.namespace === 'home' ? this.EFFEX.options.duration_logo_anim : 0;
			this.initScroll( false );
			this.scrollTo( y, this.options.time_fade_out );
		}

		// transition header to coincide position on next page
		if ( this.options.fakeHeaderTransition && !is_view && this.window.innerWidth >= 1204 ){
			y = this.getPositionScroll().y;
			if ( y > 0){

				// if from HOME to ------> other
				if ( data.current.namespace == 'home' && !this.dom.hasClass( this.body, 'desktop-header-overlap' ) ){
					return;
				}

				// if from other to -------> HOME
				if ( data.trigger && this.dom.hasClass( data.trigger, 'logo' ) ){
					return;
				}


				this.initScroll( false );
				this.dom.removeClass( this.body, 'desktop-header-sticky' );
				this.dom.removeClass( this.body, 'desktop-header-overlap' );
				let headerEl = this.qs('#header .int');
				gsap.to(headerEl, { y: Math.min(y,20), duration: this.options.time_fade_out, ease: 'power3.out' });
			}
		}
	}

	setEnterTransition( data ){
		let checkView = this.barba_is_view(data.current.container, data),
			is_view = checkView[0];

		// transition header to coincide position on next page
		if ( this.options.fakeHeaderTransition && !is_view && this.window.innerWidth >= 1204 ){
			this.initEffex(false);
			let headerEl = this.qs('#header .int');
			gsap.set(headerEl, { y: 0 });
			this.initEffex(true);
		}	
	}

	scrollTo( y, duration = 0.5 ){
		duration = Math.min( duration, this.options.time_fade_out );
		if (this.scroll) {
			this.scroll.scrollTo(y, {
				immediate: duration === 0,
				duration: duration
			});
		}
		else {
			gsap.to(window, { duration: duration, scrollTo: y });
		}		
	}


	recordState(b, data) {
		if (b) {
			if (data.trigger !== 'back' && data.trigger !== 'forward') {
				this.prevSTATE = {
					html: data.current.html,
					scroll: this.getPositionScroll()
				}
			}
		}
		else {
			this.prevSTATE = false;
		}
	}

	setPositionScrollAfterPageEnter(data) {
		let y = 0;
		if (data.trigger === 'back' || data.trigger === 'forward') {
			if (this.prevSTATE) {
				y = this.prevSTATE.scroll.y;
				this.recordState(false);
			}
		}

		let checkView = this.barba_is_view(data.next.container, data),
			is_view = checkView[0];
		
		if ( is_view ){
			return;
		}

		// if the menu has a class anchor, get the position to scroll for the anchor-class
		y = this.getScrollPositionIfTriggerHasClassAnchor( data.trigger, y );		

		/*
		if( data.next.namespace == 'home'  ){

			if (this.scroll) {
				this.scroll.scrollTo(this.EFFEX.options.duration_logo_anim, {
					immediate: true
				});
				this.scroll.scrollTo(y)
			}
			else {
				gsap.set(window, { scrollTo: this.EFFEX.options.duration_logo_anim  });
				gsap.to(window, { duration: 1.2, scrollTo: y });
			}

			return;
		}
		*/

		this.setEnterTransition( data );

		if (this.scroll) {
			this.scroll.scrollTo(y, {
				immediate: true
			});
		}
		else {
			gsap.to(window, { duration: 0, scrollTo: y });
		}

		
	}

	// the anchor and anchor-class are set on the li parent element trough the WP menu (Appereance)
	getScrollPositionIfTriggerHasClassAnchor( trigger, y ){
		let parent = trigger.parentNode;
		if ( parent && parent.classList && parent.classList.contains( 'anchor' ) ){
			let anchorClass = this.dom.getClassesContainingString( parent.classList, 'anchor-' );
			if ( anchorClass){
				let anchorName = anchorClass[0].replace( 'anchor-', '' );
				const scrollElement = this.dom.qs( '.' + anchorName );
				if ( scrollElement ){
					y = this.dom.offset( scrollElement ).top - 100;
				}
			}
		}
		return y;
	}

	getPositionScroll() {
		let o = {};
		if (this.scroll && this.options.is_smooth) {
			const el = this.scroll.el;
			if (el && el.dataset) {
				o.x = parseFloat(el.dataset.scrollX) || 0;
				o.y = parseFloat(el.dataset.scrollY) || 0;
			} else {
				o.x = window.pageXOffset || 0;
				o.y = window.pageYOffset || 0;
			}
		}
		else {
			o.x = window.pageXOffset || 0;
			o.y = window.pageYOffset || 0;
		}
		return o;
	}

	// -----------------------------------------------------------------[ UTILS ]--------------------------------------------------------------//
	initLoading() {
		if (!this.options.is_ajax) {
			return;
		}
		if (NProgress) {
			NProgress.configure({
				trickleSpeed: 77
			});
		}
		this.setLoading(true);
	}

	setLoading(b) {
		if (!this.options.is_ajax) {
			return;
		}
		if (NProgress) {
			if (b) {
				NProgress.start();
				this.addClass(this.body, 'page-loading');
			}
			else {
				NProgress.done();
				this.removeClass(this.body, 'page-loading');
			}
		}
	}

	log(str, args) {
		if (console) {
			if (args) {
				return console.log(str, args);
			}
			console.log(str);
		}
	}

	initLazyloading() {
		lazySizes.cfg.loadMode = 1;
		lazySizes.init();
	}

	// -----------------------------------------------------------------[ PAGES FUNCTIONS ]---------------------------------------------------//
	initPageSpecific(context, b, firstTime) {
		// context: DOM element (body or container)
		this.WIDGETS.initWidgets(context, b, firstTime);

		if (b) {

			this.initLazyloading();

			this.initGAEvents();

			this.initEffex(true, firstTime );
		}
		else {
			this.initEffex(false);

			clearAllBodyScrollLocks();
		}
	}

	//------------------------------- call after a page load via ajax outside barba somewhere -----------------------//
	onLoadAjaxContent(href, triggerEl, html, addHistory = false) {

		let parser, doc, a, title;

		this.initPageSpecific(this.body, false, false);
		setTimeout(() => this.initPageSpecific(this.body, true, false), 120);

		a = document.createElement('a');
		a.href = href;

		parser = new DOMParser();
		doc = parser.parseFromString(html, "text/html");
		title = doc.title;

		if (addHistory) {
			this.changeHTMLTitle(title);
			this.barba_history_add(href, a, title);
		}

		parser = doc = null;

		this.setGA(a.pathname, href);
	}

	// -----------------------------------------------------------------[ EFFEX ]--------------------------------------------------------------//
	initEffex(b, firstTime=false) {
		if (b) {
			this.EFFEX.init( firstTime );
		}
		else {
			this.EFFEX.destroy();
		}
	}

	//------------------------------------------------------------------[ GOOGLE ANALYTHICS ]--------------------------------------------------//
	setGA(_pathname, _href) {
		// placeholder, left intentionally blank
	}

	setGAEvent(_category, _action, _label, _value) {
		if (this.isLoggedIn()) {
			// optionally skip
		}
		// placeholder - keeping previous commented implementations removed
	}

	initGAEvents() {
		// placeholder for user event hookups - previously used jQuery event bindings
	}

	//----------------------------------------------------------------[ UTILS ]------------------------------------------------------------//
	updateAdminButton(html) {

		let el = this.qs(this.options.admin_button);
		if (!el) return;

		let doc = this.htmlToDoc(html);
		let anchor = el.querySelector('a');
		let newHrefEl = doc.querySelector(this.options.admin_button + ' a');
		if (anchor && newHrefEl) anchor.setAttribute('href', newHrefEl.getAttribute('href'));
	}

	isLoggedIn() {
		return this.hasClass(this.body, 'logged-in');
	}

	// -----------------------------------------------------------------[ FOUO SIGNATURE ]-----------------------------------------------------//
	_logFOUO(str) {
		this.log('');
		this.log('%c' + str, 'color: white; background-color: black; font-size: 12px; line-height: 28px; padding: 10px 15px 8px 15px; font-family: Helvetica;');
		this.log('');
	}

}